export default __webpack_public_path__ + "static/media/curfewDesk.be5c4c99.jpg";